module.exports = __webpack_public_path__ + "static/media/improvement-plans.d171d567.svg";